import React from 'react';
import { ViewMessageRates } from './ViewMessageRates';
import { PricingDropDown } from '../PricingDropDown';
import { regions, regionRates, balances, isInternational } from '../../../../constants/pricing';

export const Calculator = () => {
  const [typeValue, setType] = React.useState('annual');
  const [regionValue, setRegion] = React.useState('us');
  const [amountValue, setAmount] = React.useState(100);

  const typeOptions = ['monthly', 'annual'].map((type) =>
    <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>);
  const regionOptions = regions.map((region) =>
    <option key={region} value={region}>{regionRates[region].fullName}</option>);
  const balanceOptions = balances.map((balance) =>
    <option key={balance} value={balance}>{`$${balance.toLocaleString()}.00`}</option>);

  const isInt = isInternational(regionValue);

  const sms = (Math.floor(amountValue / regionRates[regionValue].rate[isInt ? typeValue : `sms_${typeValue}`])).toLocaleString();
  const mms = (Math.floor(amountValue / regionRates[regionValue].rate[isInt ? typeValue : `mms_${typeValue}`])).toLocaleString();
  const mins = (Math.floor(amountValue / regionRates[regionValue].rate[isInt ? typeValue : `call_${typeValue}`])).toLocaleString();

  return (
    <div className="flex align-center">
      <div className="calculator">
        <div className="calc-options-container">
          <p className="fsz-18 bold-900 mb-20">Message & Calls Calculator</p>
          <div className="drop-down-container">
            <PricingDropDown
              title="Select Type"
              value={typeValue}
              setValue={setType}
              options={typeOptions}
            />
            <PricingDropDown
              title="Select Country"
              value={regionValue}
              setValue={setRegion}
              options={regionOptions}
            />
            <PricingDropDown
              title="Select Amount"
              value={amountValue}
              setValue={setAmount}
              options={balanceOptions}
            />
          </div>
        </div>
        <div className="calc-results">
          <table>
            <tbody>
              <tr>
                <td>SMS</td>
                <td>{sms}</td>
              </tr>
              <tr><td className='fsz-10'>Or</td></tr>
              <tr>
                <td>MMS</td>
                <td>{mms}</td>
              </tr>
              <tr><td className='fsz-10'>Or</td></tr>
              <tr>
                <td>Mins</td>
                <td>{mins}</td>
              </tr>
            </tbody>
          </table>
          <p className="fsz-10">
            * Calculations are approximations. SMS and MMS prices may vary.
            Additional carrier fees may apply.
            &nbsp;
            <ViewMessageRates
              klass="white underline"
              linkName="View Rates."
            />
          </p>
        </div>
      </div>
    </div>
  );
};
